import React from 'react'
import './footer.css'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {FaFacebookSquare} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="/" className="footer__logo">Ravi Chaudhary</a>
      <ul className="permalinks">
        <li><a href="/">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        {/* <li><a href="#portfolio">Portfolio</a></li> */}
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
        <a href="https://www.facebook.com/chaudharyravi290"><FaFacebookSquare /></a>
        <a href="https://www.linkedin.com/in/ravi-chaudhary-73b4b717a/"><BsLinkedin /></a>
        <a href="https://github.com/chyravi290"><FaGithub /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Ravi Chaudhary. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default Footer